import { render, staticRenderFns } from "./WithholdingTaxEditor.vue?vue&type=template&id=29f55bf4&"
import script from "./WithholdingTaxEditor.vue?vue&type=script&lang=js&"
export * from "./WithholdingTaxEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports